import { ComparisonGraph } from "@/features/StoreCompare/types";

export function hasAlertInChartData(graphs: ComparisonGraph[]) {
  return graphs.some((graph) => {
    return graph.visitCounts.chartItems.some((chartItem) => {
      return chartItem.isAlert;
    });
  });
}
